<template>
   <div class="modal fade" id="confirmDelete" role="dialog" aria-labelledby="confirmDeleteLabel" aria-hidden="true" @click="close" v-show="show">
      <div class="modal-dialog" >
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title">Delete Confirmation</h4>
          </div>
          <div class="modal-body">
            <p id="message">Are you sure you want to delete {{ deleteName() }}?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" @click="close()">Cancel</button>
            <button type="button" class="btn btn-danger" id="confirm" @click="confirmed()">Delete</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default{
        props:['delete'],
        data(){
            return {
                show : false,
                showModal : false
            }
        },
        methods:{
            close(){
                this.show = false;
            },
            confirmed(){
                this.close();
                $('#deleteForm').submit();
            },
            deleteName(){
                return this.delete.name;
            }
        },
        mounted(){
            document.addEventListener("keydown", (e) => {
               if (this.show && e.keyCode == 27) {
                    this.close();
                }
            });
        }
    }
</script>
